(function () {
  'use strict';

  angular
    .module('morningFlightAfterNightFlight')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('morningFlightAfterNightFlight', {
        url: '/morning-flight-after-night-flight',
        views: {
          'morningFlightAfterNightFlightView': {
            templateUrl: 'morning-flight-after-night-flight/views/morning-flight-after-night-flight.tpl.html',
            controller: 'morningFlightAfterNightFlightCtrl',
            controllerAs: 'morningFlightAfterNightFlight'
          }
        }
      });
  }
}());
